import { useEffect } from 'react';
import { getCookieValue } from './CookieConsent';

function initGA(id) {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };

    const consent = getCookieValue('consentCookie');
    const granted = consent === '1' || consent === '2';

    window.gtag('consent', 'default', {
        analytics_storage: granted ? 'granted' : 'denied',
        ad_storage: 'denied',
        wait_for_update: 500,
    });

    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    script.async = true;
    document.head.appendChild(script);

    window.gtag('js', new Date());
    window.gtag('config', id);
}

function grantConsent() {
    if (!window.gtag) return;
    window.gtag('consent', 'update', { analytics_storage: 'granted' });
}

function GoogleAnalytics() {
    const seoSettings = window.__WEBSITE__?.seoSettings || {};
    const { googleAnalyticsId, showCookieConsent } = seoSettings;

    useEffect(() => {
        if (!googleAnalyticsId || !showCookieConsent) return;

        initGA(googleAnalyticsId);

        window.addEventListener('cookieConsentAccepted', grantConsent);
        return () => window.removeEventListener('cookieConsentAccepted', grantConsent);
    }, []);

    return null;
}

export default GoogleAnalytics;
